import { rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const SensorPropertiesWrapper = styled.div`
	.MuiSkeleton-text {
		max-width: ${rem(200)};
	}
`;
